import { atom } from 'jotai';

// Signál na okamžité obnovenie zoznamu dokumentov (napr. po nahratí súborov),
// nezávisle od 15s pollu. Zvýšením hodnoty sa v DocumentsList spustí refetch.
export const docsRefreshAtom = atom(0);
